import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11 18h-6a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v3","key":"svg-0"}],["path",{"d":"M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0","key":"svg-1"}],["path",{"d":"M6 12h.01","key":"svg-2"}],["path",{"d":"M18.42 15.61a2.1 2.1 0 1 1 2.97 2.97l-3.39 3.42h-3v-3z","key":"svg-3"}]]

const IconCashBanknoteEdit = createReactComponent('outline', 'cash-banknote-edit', 'CashBanknoteEdit', __iconNode);

export default IconCashBanknoteEdit;